import { ApiError } from './apiClient';

type SerializableApiError = {
  name: string;
  message: string;
  status: number;
  code: string;
  response?: unknown;
};

export function toApiError(error: any): SerializableApiError {
  if (error instanceof ApiError) {
    return {
      name: error.name || "ApiError",
      message: error.message,
      status: typeof error.status === 'number' ? error.status : 500,
      code: error.code || "UNKNOWN_ERROR",
      response: error.response,
    };
  }

  const status = typeof error?.status === 'number' ? error.status : 500;
  const name = typeof error?.name === 'string' ? error.name : 'ApiError';
  const code = typeof error?.code === 'string' ? error.code : name;
  const message = typeof error?.message === 'string' ? error.message : String(error ?? 'Unknown error');

  return {
    name,
    message,
    status,
    code,
    response: error?.response,
  };
}
